import { render, staticRenderFns } from "./TvappDetail.vue?vue&type=template&id=7e3a8331&scoped=true&"
import script from "./TvappDetail.vue?vue&type=script&lang=js&"
export * from "./TvappDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3a8331",
  null
  
)

component.options.__file = "TvappDetail.vue"
export default component.exports